module.exports = __webpack_public_path__ + "img/nginx.3b4ece14.png";